<script setup>
import {computed, ref, onMounted, onUnmounted} from 'vue';
import {usePage} from '@inertiajs/vue3';
import NavItem from '@/Components/NavItem.vue';
import SelectLanguages from '@/Components/SelectLanguages.vue';

const service = computed(() => usePage().props.service);

const menus = computed(() => {
    return [
        {title: 'ទំព័រដើម', routeName: 'home.index', component: 'Home'},
        {
            title: 'សេវាកម្ម',
            routeName: 'our.service.detail',
            component: 'OurServiceDetail',
            children: service.value.map(item => {
                return {
                    title: item.title,
                    routeName: 'our.service.detail',
                    params: item.id,
                    component: 'OurServiceDetail'
                };
            })
        },
        {title: 'ផលិតផល', routeName: 'our.product.detail', component: 'OurProductDetail'},
        {title: 'អំពីយើង', routeName: 'about.us', component: 'AboutUs'},
        {title: 'ទំនាក់ទំនង', routeName: 'contact.us', component: 'ContactUs'},
        {title: 'អាជីព', routeName: 'career', component: 'Career'},
    ];
});

// const languages = [
//     {
//         title: 'ភាសា',
//         children: [
//             {title: 'ខ្មែរ', img: '/assets/988tech/img/flag/kh.png', active: true},
//             {title: 'English', img: '/assets/988tech/img/flag/en.png', active: false},
//         ],
//     },
// ];

const currentRouteName = computed(() => usePage().component);
const isMobileMenuOpen = ref(false);
const isScrolled = ref(false);

const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const handleClickOutside = (event) => {
    if (
        isMobileMenuOpen.value &&
        !event.target.closest(".mobile-menu") &&
        !event.target.closest(".menu-toggle")
    ) {
        isMobileMenuOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener("click", handleClickOutside);
});

const handleScroll = () => {
    isScrolled.value = window.scrollY > 50;
};

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
    <nav>
        <ul class="hidden xl:flex space-x-6 p-4">
            <template v-for="(item, index) in menus" :key="index">
                <NavItem
                :title="item.title"
                :routeName="item.routeName"
                :active="currentRouteName === item.component"
                :children="item.children"
                />
            </template>

            <!-- <template v-for="(item, index) in languages" :key="index">
                <SelectLanguages
                :title="item.title"
                :children="item.children"
                />
            </template> -->
        </ul>

        <button class="menu-toggle flex xl:hidden space-x-6 px-0" @click="toggleMobileMenu">
            <span>
                <i class="ri-align-justify text-[27px] text-primaryColor p-0.5 rounded"
                   :class="[
                    isScrolled ? 'border border-primaryColor/20 shadow': 'border border-primaryColor/20'
                ]"></i>
            </span>
        </button>

        <div v-if="isMobileMenuOpen"
             class="fixed inset-0 bg-black/50 transition-opacity duration-200 ease-in-out overlay-bg"
             @click="toggleMobileMenu">
        </div>

        <div
            class="z-50 fixed top-0 right-0 w-3/5 h-screen bg-white shadow-lg transition-transform transform mobile-menu duration-200 ease-in-out"
            :class="{
                'translate-x-full': !isMobileMenuOpen,
                'translate-x-0': isMobileMenuOpen,
            }">

            <button class="absolute z-50 top-3 right-3 text-gray-700 border rounded-full w-9 h-9"
                    @click="toggleMobileMenu">
                ✖
            </button>

            <ul class="mt-0 space-y-2 p-3">
                <template v-for="(item, index) in menus" :key="index">
                    <NavItem
                    :title="item.title"
                    :routeName="item.routeName"
                    :active="currentRouteName === item.component"
                    :children="item.children"
                    />
                </template>

                <template v-for="(item, index) in languages" :key="index">
                    <SelectLanguages
                    :title="item.title"
                    :children="item.children"
                    />
                </template>
            </ul>
        </div>
    </nav>
</template>
